import Vue from 'vue'
import observerLog from '@didi/tools-observer-log' // 曝光埋点
import { trackEvent } from '@/common/utils/log.js'
import eventMap from './eventMap'

// https://git.xiaojukeji.com/soda-fe/xingtian/observer-log
Vue.use(observerLog, eventMap, ({ eventId, attrs }) => {
  trackEvent(eventId, attrs)
})
